/* SET STATE */
export const SET_STATE_LABREQUESTREQ = "SET_STATE_LABREQUESTREQ"

/* LABREQUESTREQS */
export const GET_LABREQUESTREQS = "GET_LABREQUESTREQS"
export const GET_LABREQUESTREQS_SUCCESS = "GET_LABREQUESTREQS_SUCCESS"
export const GET_LABREQUESTREQS_FAIL = "GET_LABREQUESTREQS_FAIL"

/* LABREQUESTREQ */
export const GET_LABREQUESTREQ = "GET_LABREQUESTREQ"
export const GET_LABREQUESTREQ_SUCCESS = "GET_LABREQUESTREQ_SUCCESS"
export const GET_LABREQUESTREQ_FAIL = "GET_LABREQUESTREQ_FAIL"

/**
 * ADD LABREQUESTREQ
 */
 export const ADD_NEW_LABREQUESTREQ = "ADD_NEW_LABREQUESTREQ"
 export const ADD_LABREQUESTREQ_SUCCESS = "ADD_LABREQUESTREQ_SUCCESS"
 export const ADD_LABREQUESTREQ_FAIL = "ADD_LABREQUESTREQ_FAIL"

 /**
 * UPDATE LABREQUESTREQ
 */
export const UPDATE_LABREQUESTREQ = "UPDATE_LABREQUESTREQ"
export const UPDATE_LABREQUESTREQ_SUCCESS = "UPDATE_LABREQUESTREQ_SUCCESS"
export const UPDATE_LABREQUESTREQ_FAIL = "UPDATE_LABREQUESTREQ_FAIL"

/**
 * DELETE LABREQUESTREQ
 */
export const DELETE_LABREQUESTREQ = "DELETE_LABREQUESTREQ"
export const DELETE_LABREQUESTREQ_SUCCESS = "DELETE_LABREQUESTREQ_SUCCESS"
export const DELETE_LABREQUESTREQ_FAIL = "DELETE_LABREQUESTREQ_FAIL"
